export var AudienceType;
(function (AudienceType) {
    AudienceType["SYNDICATED"] = "SYNDICATED";
    AudienceType["CUSTOM"] = "CUSTOM";
})(AudienceType || (AudienceType = {}));
export var AudiencePricingStructure;
(function (AudiencePricingStructure) {
    AudiencePricingStructure["CPM"] = "CPM";
    AudiencePricingStructure["PERCENT_MEDIA"] = "PERCENT_MEDIA";
    AudiencePricingStructure["HYBRID"] = "HYBRID";
})(AudiencePricingStructure || (AudiencePricingStructure = {}));
export var DSP;
(function (DSP) {
    DSP["THE_TRADE_DESK"] = "The Trade Desk";
    DSP["GOOGLE_DV360"] = "Google (DV360)";
    DSP["STACK_ADAPT"] = "StackAdapt";
    DSP["ADOBE"] = "Adobe";
    DSP["LINKEDIN_ADS"] = "LinkedIn Ads";
    DSP["META"] = "Meta";
    DSP["X"] = "X";
    DSP["TIKTOK_FOR_BUSINESS"] = "TikTok for Business";
    DSP["PINTEREST"] = "Pinterest";
    DSP["SNAPCHAT"] = "Snapchat";
    DSP["AMAZON_DSP"] = "Amazon DSP";
    DSP["PUBMATIC"] = "PubMatic";
    DSP["MEDIAMATH_BY_INFILLION"] = "MediaMath by Infillion";
    DSP["SIMPLI_FI"] = "Simpli.fi";
    DSP["MADHIVE"] = "Madhive";
    DSP["VIANT"] = "Viant";
    DSP["MOUNTAIN"] = "Mountain";
    DSP["BASIS"] = "Basis";
    DSP["ILLUMIN"] = "Illumin";
    DSP["RTB_HOUSE"] = "RTB House";
    DSP["SAMSUNG_ADS"] = "Samsung Ads";
    DSP["PARAMOUNT"] = "Paramount";
    DSP["LG_AD_SOLUTIONS"] = "LG Ad Solutions";
    DSP["WARNER_BROS_DISCOVERY"] = "Warner Bros. Discovery";
    DSP["COX_MEDIA"] = "Cox Media";
    DSP["SPECTRUM_CHARTER"] = "Spectrum / Charter";
})(DSP || (DSP = {}));
export var Category;
(function (Category) {
    Category["FIRMOGRAPHICS"] = "Firmographics";
    Category["DEMOGRAPHICS"] = "Demographics";
    Category["TECHNOGRAPHICS"] = "Technographics";
    Category["INTENT_TOPICS"] = "Intent Data";
    Category["SEGMENT_GROUPING"] = "Segment Grouping";
})(Category || (Category = {}));
export const marketplaceDSPs = [
    'LinkedIn Ads',
    'Meta',
    'X',
    'TikTok for Business',
    'Pinterest',
    'Snapchat',
    'Amazon DSP',
    'PubMatic',
    'MediaMath by Infillion',
    'Simpli.fi',
    'Madhive',
    'Viant',
    'Mountain',
    'Basis',
    'Illumin',
    'RTB House',
    'Samsung Ads',
    'Paramount',
    'LG Ad Solutions',
    'Warner Bros. Discovery',
    'Cox Media',
    'Spectrum / Charter',
];
export var Criteria;
(function (Criteria) {
    Criteria["BiotechnologyIntent"] = "Biotechnology Intent";
    Criteria["BusinessEvents"] = "Business Events";
    Criteria["BusinessIntent"] = "Business Intent";
    Criteria["BusinessSizeClassification"] = "Business Size Classification";
    Criteria["DecisionMaker"] = "Decision Maker";
    Criteria["EmployeeCount"] = "Employee Count";
    Criteria["EnergyConstructionManufacturingIntent"] = "Energy/Construction/Manufacturing Intent";
    Criteria["FinanceIntent"] = "Finance Intent";
    Criteria["Fortune500"] = "Fortune 500";
    Criteria["GovernmentIntent"] = "Government Intent";
    Criteria["HealthCareIntent"] = "HealthCare Intent";
    Criteria["HumanResourcesIntent"] = "Human Resources Intent";
    Criteria["Industry"] = "Industry";
    Criteria["JobSeniority"] = "Job Seniority";
    Criteria["JobFunction"] = "Job Function";
    Criteria["LegalIntent"] = "Legal Intent";
    Criteria["LogisticsIntent"] = "Logistics Intent";
    Criteria["Longevity"] = "Longevity";
    Criteria["MarketingIntent"] = "Marketing Intent";
    Criteria["RetailIntent"] = "Retail Intent";
    Criteria["RevenueSize"] = "Revenue Size";
    Criteria["Technologies"] = "Technologies";
    Criteria["TechnologyIntent"] = "Technology Intent";
    Criteria["SegmentsList"] = "Segments List";
})(Criteria || (Criteria = {}));
//# sourceMappingURL=Audience.js.map